var activityEvents, script_loaded = !1;

if (typeof __isPSA === "undefined") var __isPSA = !1;

if (typeof uLTS === "undefined") {
  var uLTS = new MutationObserver(e => {});
  uLTS.observe(document.documentElement, {
    childList: !0,
    subtree: !0
  });
}

function loadJSscripts() {
  if (script_loaded) return;
  if (typeof uLTS !== "undefined") uLTS.disconnect();
  if (typeof window.yett !== "undefined") window.yett.unblock();
  script_loaded = !0;

  document.querySelectorAll("iframe[data-src], script[data-src]").forEach(e => {
    const datasrc = e.dataset.src;
    if (datasrc != null) e.src = datasrc;
  });

  document.querySelectorAll("link[data-href]").forEach(e => {
    const datahref = e.dataset.href;
    if (datahref != null) e.href = datahref;
  });

  document.querySelectorAll("script[type='text/lazyload']").forEach(e => {
    const t = document.createElement("script");
    for (let a = 0; a < e.attributes.length; a++) {
      const r = e.attributes[a];
      t.setAttribute(r.name, r.value);
    }
    t.type = "text/javascript";
    t.innerHTML = e.innerHTML;
    e.parentNode.insertBefore(t, e);
    e.parentNode.removeChild(e);
  });

  document.dispatchEvent(new CustomEvent("asyncLazyLoad"));
  setTimeout(() => {
    document.dispatchEvent(new CustomEvent("loadBarInjector"));
  }, 1000);
}

if (__isPSA) {
  ["mousedown", "mousemove", "keydown", "scroll", "touchstart", "click", "keypress", "touchmove"]
    .forEach(e => {
      window.addEventListener(e, loadJSscripts, !1);
    });
} else {
  loadJSscripts();
}
